<template>
  <div
      :id="data.Id"
      :data-elementindex="getElementIndex"
      :style="getStyles"
      :data-translateX="data.X"
      :data-translateY="data.Y"
      :data-rotate="data.RotateDegree"
      :data-gradient="data.isGradient"
      :contenteditable="isEditable"
      :class="getClass"
      data-isselect="0"
      data-type="text"
  >

    <div
        :style="[getStylesFocusTextDiv]"
        :id="'editor-'+data.Id"
        class="focus-text-div outline-text"
        @keyup.stop="updateTheTextValue">
      <div v-html="getHtml"/>
    </div>
    <svg
        v-if="data.outLine.textEffect != 'none'"
        xmlns="http://www.w3.org/2000/svg"
        style="width: 0px!important; height: 0px!important;">
      <filter :id="getFilterId">
        <feMorphology
            :radius="getOutlineStrokeWidth"
            in="SourceAlpha"
            result="Dilated"
            operator="dilate"/>
        <feFlood
            :flood-color="data.outLine.strokeColor"
            result="OutlineColor"/>
        <feComposite
            in="OutlineColor"
            in2="Dilated"
            operator="in"
            result="Outline"/>
        <feMerge>
          <feMergeNode in="Outline"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </svg>

  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import twemoji from 'twemoji';

export default {
  name:  'TextComponent',
  props: {
    data:                  Object,
    elementIndex:          Number,
    isRenderingPagePanel:  Boolean,
    isFakeRendering:       { type: Boolean, default: false },
    isAnimationInProgress: {
      type:    Boolean,
      default: false,
    },
    isGroupChild: { type: Boolean, default: false },
  },
  data() {
    return {
      editor:     null,
      isEditable: false,
    };
  },
  computed: {

    getFilterId() {
      return this.isAnimationInProgress ? `filter-anim-${this.data.Id}` : `filter-${this.data.Id}`;
    },
    getOutlineStrokeWidth() {
      const fontsize = parseInt(this.data.fontSize);
      return (this.data.outLine.strokeWidth * (fontsize / 10)) / 10;
    },
    getElementIndex() {
      if (this.isGroupChild) {
        return typeof this.elementIndex === 'number' ? this.elementIndex : -1;
      }
      return this.data.elementIndex;
    },
    getStylesFocusTextDiv() {
      const {
        lineSpacing, fontFamily,
        fontSize, color, IsVisible, isBold, isItalic, isUnderline, gradient, isGradient, shapeType,
      } = this.data;

      let gradientStyles = {};

      if (isGradient) {
        const startColorString   = gradient.colors[0].rgba;
        const endColorString     = gradient.colors[1].rgba;
        const startColor         = this.parseRGBA(startColorString);
        const endColor           = this.parseRGBA(endColorString);
        const startColorPosition = gradient.colors[0].position;
        const endColorPosition   = gradient.colors[1].position;
        const curvedLettersReady = typeof this.data.Value === 'string'
            && this.data.Value.indexOf('curve-letter') !== -1;
        const isCurved = shapeType && shapeType == 'curve' && !this.data.isEditorEnable && curvedLettersReady;
        if (isCurved) {
          gradientStyles = {
            '--start-r': startColor.r,
            '--start-g': startColor.g,
            '--start-b': startColor.b,
            '--start-a': startColor.a,
            '--end-r':   endColor.r,
            '--end-g':   endColor.g,
            '--end-b':   endColor.b,
            '--end-a':   endColor.a,
            '--pos-a':   startColorPosition,
            '--pos-b':   endColorPosition,

          };
        } else {
          // Paint past the line box. The matching negative margin keeps the
          // line, wrapping, and measured height where they are without a gradient.
          const filters = [];
          if (this.data.outLine && this.data.outLine.textEffect && this.data.outLine.textEffect !== 'none') {
            filters.push(this.isAnimationInProgress ? `url(#filter-anim-${this.data.Id})` : `url(#filter-${this.data.Id})`);
          }
          if (this.data.textShadow && this.data.textShadow.textEffect === 'shadow') {
            const shadow = this.data.textShadow;
            filters.push(`drop-shadow(${shadow.shadowOffsetX}px ${shadow.shadowOffsetY}px ${shadow.shadowBlur}px ${shadow.shadowColor})`);
          }
          const angle = Number(gradient.angle) || 0;
          const c0    = gradient.colors[0].rgba;
          const c1    = gradient.colors[1].rgba;
          const p0    = gradient.colors[0].position;
          const p1    = gradient.colors[1].position;
          // Padding is even on every side. Shift the stops by that same distance
          // along the gradient so the letters keep the original colors.
          const inset = `1.2em * (abs(sin(${angle}deg)) + abs(cos(${angle}deg)))`;
          const background = `-webkit-linear-gradient(${angle}deg, ${c0} calc(${inset} + (100% - 2 * (${inset})) * ${p0} / 100), ${c1} calc(${inset} + (100% - 2 * (${inset})) * ${p1} / 100))`;
          gradientStyles = {
            background,
            webkitBackgroundClip: 'text',
            backgroundClip:       'text',
            webkitTextFillColor:  'transparent',
            boxSizing:            'content-box',
            padding:              '1.2em',
            marginTop:            '-1.2em',
            marginRight:          '-1.2em',
            marginBottom:         '-1.2em',
            marginLeft:           '-1.2em',
            overflow:             'visible',
            filter:               filters.join(' ') || 'none',
          };
        }
      }

      const toReturn = {
        fontSize:       (typeof fontSize === 'string' && fontSize.endsWith('px')) ? fontSize : `${fontSize}px`,
        lineHeight:     lineSpacing,
        color,
        fontFamily:     "'" + `${this.data.fontFamily}` + "'",
        width:          this.data.shapeType && this.data.shapeType === 'curve' ? '100%' : 'auto',
        height:         'auto !important',
        visibility:     IsVisible ? 'visible' : 'hidden',
        fontWeight:     isBold ? 'bold' : 'normal',
        fontStyle:      isItalic ? 'italic' : 'normal',
        textDecoration: isUnderline ? 'underline' : 'none',
        textAlign:      this.getHorizontalAlign,
        overflowWrap:   'break-word',
        padding:        '0px 0px',
        filter:         this.isAnimationInProgress ? `url(#filter-anim-${this.data.Id})` : `url(#filter-${this.data.Id})`,
        marginBottom:   this.data.shapeType && this.data.shapeType === 'curve' && !this.data.isEditorEnable && (parseInt(this.data.curve, 10) < 0) ? '1.3em' : '0',
        maxWidth:       '100%',
      };
      return { ...toReturn, ...gradientStyles };
    },

    getStyles() {
      const {
        X, Y, RotateDegree, scaleX, scaleY, Width, Height, PdfSortOrder, IsVisible, isEditorEnable, gradient,
      } = this.data;

      const pointerEvents = (this.data.locked) ? 'none' : 'all';
      let shadowCSS       = { textShadow: this.data.textShadow.textEffect === 'shadow' ? `${this.data.textShadow.shadowOffsetX}px ${this.data.textShadow.shadowOffsetY}px ${this.data.textShadow.shadowBlur}px ${this.data.textShadow.shadowColor}` : '' };

      const curvedLettersReady = typeof this.data.Value === 'string'
          && this.data.Value.indexOf('curve-letter') !== -1;
      const curvePaintsOwnColors = this.data.shapeType === 'curve' && !this.data.isEditorEnable && curvedLettersReady;
      if (this.data.isGradient && curvePaintsOwnColors) {
        shadowCSS = { filter: this.data.textShadow.textEffect === 'shadow' ? `drop-shadow(${this.data.textShadow.shadowOffsetX}px ${this.data.textShadow.shadowOffsetY}px ${this.data.textShadow.shadowBlur}px ${this.data.textShadow.shadowColor})` : '' };
      } else if (this.data.isGradient) {
        shadowCSS = { filter: '' };
      }

      const horizontalAlign = this.getHorizontalAlign == 'center' ? 'center' : (this.getHorizontalAlign == 'right') ? 'end' : 'start';


      const toReturn =  {
        transform:       `rotate(${RotateDegree}deg) scale(${scaleX},${scaleY})`,
        transformOrigin: 'center center',
        zIndex:          PdfSortOrder,
        width:           `${Width}px`,
        left:            `${X}px`,
        top:             `${Y}px`,
        height:          `${Height}px`,
        visibility:      IsVisible ? 'visible' : 'hidden',
        cursor:          isEditorEnable ? 'text' : '',
        display:         'flex',
        alignItems:      this.getVerticalAlignValue,
        overflowY:       'initial',
        pointerEvents,
        justifyContent:  horizontalAlign,
      };
      return { ...toReturn, ...shadowCSS };
    },
    getClass() {
      let classes = 'position-absolute text-object';
      if (this.data.shapeType && this.data.shapeType === 'curve') {
        classes += ' curve-text-div';
      }
      // Always selectable so shift/marquee can hit group children (promoted to group on select).
      classes += ' target';
      return classes;
    },
    getHtml() {
      return typeof this.data.Value === 'string' ? this.data.Value : this.data.Value.firstElementChild.outerHTML;
    },
    getVerticalAlign() {
      const verticalAlign = this.data.verticalAlign.toLowerCase();
      if (verticalAlign == 'middle') {
        return 'center';
      }
      if (verticalAlign == 'top') {
        return 'flex-start';
      }
      if (verticalAlign == 'bottom') {
        return 'flex-end';
      }

      return 'flex-start';
    },
    getHorizontalAlign() {
      if (this.data.isJustifyCenter) {
        return 'center';
      }
      if (this.data.isJustifyLeft) {
        return 'left';
      }
      if (this.data.isJustifyRight) {
        return 'right';
      }
      if (this.data.isJustify) {
        return 'justify';
      }
    },
    outlineStyles() {
      const stroke = `${this.strokeWidth}px`;
      return {
        '--stroke-width': stroke,
        '--stroke-color': this.strokeColor,
      };
    },
    getVerticalAlignValue() {
      const align = this.getVerticalAlign;
      return align;
    },
  },
  mounted() {
    if (!this.isFakeRendering) {
      const text                   = document.getElementById(this.data.Id).firstElementChild;
      const focusTextDivFirstChild = text.firstElementChild;

      try {
        if (focusTextDivFirstChild && focusTextDivFirstChild.clientHeight > this.data.Height && this.data.isTextAdjustmentsNeeded) {
          this.makeTextAdjustments(focusTextDivFirstChild);
        }
      } catch (e) {
        console.log(e.message);
      }
    }

    if (!this.isFakeRendering) {
      EventBus.$off('insertEmoji', this.insertEmojiAtCursor);
      EventBus.$on('insertEmoji', this.insertEmojiAtCursor);
    }
  },

  beforeDestroy() {
    EventBus.$off('insertEmoji', this.insertEmojiAtCursor);
  },
  methods: {
    insertEmojiAtCursor(payload) {
      if (this.isFakeRendering) { return; }

      const emoji    = payload.emoji;
      const targetId = payload.targetId;
      const eventId  = payload.eventId;

      if (!emoji) { return; }
      if (targetId && targetId !== this.data.Id) { return; }
      if (eventId) {
        const key = '__lastProcessedEmojiEventId';
        if (window[key] === eventId) { return; }
        window[key] = eventId;
      }

      const editor = document.getElementById(`editor-${this.data.Id}`);
      if (!editor) { return; }

      editor.focus();

      const selection = window.getSelection();
      let range;

      if (!selection || selection.rangeCount === 0) {
        const span       = document.createElement('span');
        span.textContent = emoji;
        editor.appendChild(span);
        twemoji.parse(span, {
          className:  'emoji',
          callback:   icon => `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${icon}.svg`,
          attributes: () => ({
            draggable:   'false',
            crossorigin: 'anonymous',
            style:       'display:inline-block;width:1em;height:1em;max-width:1em;line-height:1;vertical-align:-0.15em;margin:0 0.05em;pointer-events:none;',
          }),
        });
      } else {
        range            = selection.getRangeAt(0);
        const span       = document.createElement('span');
        span.textContent = emoji;

        range.deleteContents();
        range.insertNode(span);

        range.setStartAfter(span);
        range.setEndAfter(span);

        selection.removeAllRanges();
        selection.addRange(range);
        twemoji.parse(span, {
          className:  'emoji',
          callback:   icon => `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${icon}.svg`,
          attributes: () => ({
            draggable:   'false',
            crossorigin: 'anonymous',
            style:       'display:inline-block;width:1em;height:1em;max-width:1em;line-height:1;vertical-align:-0.15em;margin:0 0.05em;pointer-events:none;',
          }),
        });
      }

      this.updateTheTextValue();
    },
    parseRGBA(rgbaString) {
      const values = rgbaString.substring(rgbaString.indexOf('(') + 1, rgbaString.lastIndexOf(')')).split(',');
      const r      = parseInt(values[0], 10);
      const g      = parseInt(values[1], 10);
      const b      = parseInt(values[2], 10);
      const a      = parseFloat(values[3]);
      return {
        r, g, b, a,
      };
    },
    updateTheTextValue() {
      EventBus.$emit(ApplicationEventTypes.TextObjectEvents.TEXT_SELECTION_UPDATED, this.getTextSelectionProperties);
      const text                   = document.getElementById(this.data.Id).firstElementChild;
      const focusTextDivFirstChild = text.firstElementChild;
      this.makeTextAdjustments(focusTextDivFirstChild);
    },
    makeTextAdjustments(element) {
      const allSpans = element.querySelectorAll('span, font, div, ul, img.emoji');
      const max      = this.findMaxFont(allSpans);
      if (!allSpans.length || max === 1) {
        return;
      }
      let count = 0;
      while (element.clientHeight > this.data.Height && count < 100) {
        this.decreaseFontSize(allSpans, max, element);
        count += 1;
      }
      const adjustedFontSize = this.findMaxFont(allSpans);
      EventBus.$emit('UpdateTextObjectValue', {
        value:    element.outerHTML,
        index:    this.getElementIndex,
        id:       this.data.Id,
        fontSize: adjustedFontSize,
      }); // TODO:It update the value when text adjust the container
    },
    decreaseFontSize(allSpans, max, element) {
      for (let i = 0; i < allSpans.length; i++) {
        if (allSpans[i].style.fontSize === '' && allSpans[i].tagName === 'DIV') {
          continue;
        }


        if (allSpans[i].style.fontSize === '') {
          allSpans[i].style.fontSize = this.getComputedFontStyle(allSpans[i]);
        }

        if (element.clientHeight <= this.data.Height) {
          break;
        }

        if (allSpans[i].tagName === 'UL') {
          this.updateULFontSize(allSpans[i], max);
        } else {
          const fontSize = parseInt(parseFloat(allSpans[i].style.fontSize) - parseFloat(allSpans[i].style.fontSize) / max, 10);
          if (fontSize > 4) {
            allSpans[i].style.fontSize = `${fontSize}px`;
          }
        }
      }
    },
    findMaxFont(allSpans) {
      let maxFontSize = 1;
      for (let i = 0; i < allSpans.length; i++) {
        allSpans[i].style.fontSize === '' && (allSpans[i].style.fontSize = this.getComputedFontStyle(allSpans[i]));
        parseFloat(allSpans[i].style.fontSize) > maxFontSize && (maxFontSize = parseFloat(allSpans[i].style.fontSize));
      }
      return maxFontSize;
    },
    updateULFontSize(ul, max) {
      const listElements = [...ul.children].filter(elm => elm.matches('li'));
      for (let listIter = 0; listIter < listElements.length; listIter += 1) {
        if (listElements[listIter].style.fontSize === '') {
          listElements[listIter].style.fontSize = this.getComputedFontStyle(listElements[listIter]);
          const fontSize                        = parseInt(parseFloat(listElements[listIter].style.fontSize) - parseFloat(listElements[listIter].style.fontSize) / max, 10);
          console.log('changing font to ', fontSize);
          if (fontSize > 4) {
            listElements[listIter].style.fontSize = `${fontSize}px`;
          }
        }
      }
    },
    getComputedFontStyle(element) {
      return window.getComputedStyle(element, null).getPropertyValue('font-size');
    },
  },
};
</script>
<style lang="scss">
.focus-text-editor {
  outline: dashed 2px gray;
  outline-offset: 5px;
}

.focus-text-div {
  height: 100% !important;

  ul, ol {
    padding: 0px;
  }

  li {
    margin-left: calc(1.7 * 1em);
    padding-left: 5px;
  }

  .li-center-align {
    list-style-position: inside;
    margin-left: 0px;
    margin-right: 0px;
  }

  .li-right-align {
    list-style-position: inside;
    margin-left: 0px;
  }
}

.parent-font-inherit {
  font-family: inherit;
}

.outline-text {
  text-shadow: calc(var(--stroke-width) * 1) calc(var(--stroke-width) * 0) 0 var(--stroke-color),
  calc(var(--stroke-width) * 0.9239) calc(var(--stroke-width) * 0.3827) 0 var(--stroke-color),
  calc(var(--stroke-width) * 0.7071) calc(var(--stroke-width) * 0.7071) 0 var(--stroke-color),
  calc(var(--stroke-width) * 0.3827) calc(var(--stroke-width) * 0.9239) 0 var(--stroke-color),
  calc(var(--stroke-width) * 0) calc(var(--stroke-width) * 1) 0 var(--stroke-color),
  calc(var(--stroke-width) * -0.3827) calc(var(--stroke-width) * 0.9239) 0 var(--stroke-color),
  calc(var(--stroke-width) * -0.7071) calc(var(--stroke-width) * 0.7071) 0 var(--stroke-color),
  calc(var(--stroke-width) * -0.9239) calc(var(--stroke-width) * 0.3827) 0 var(--stroke-color),
  calc(var(--stroke-width) * -1) calc(var(--stroke-width) * 0) 0 var(--stroke-color),
  calc(var(--stroke-width) * -0.9239) calc(var(--stroke-width) * -0.3827) 0 var(--stroke-color),
  calc(var(--stroke-width) * -0.7071) calc(var(--stroke-width) * -0.7071) 0 var(--stroke-color),
  calc(var(--stroke-width) * -0.3827) calc(var(--stroke-width) * -0.9239) 0 var(--stroke-color),
  calc(var(--stroke-width) * 0) calc(var(--stroke-width) * -1) 0 var(--stroke-color),
  calc(var(--stroke-width) * 0.3827) calc(var(--stroke-width) * -0.9239) 0 var(--stroke-color),
  calc(var(--stroke-width) * 0.7071) calc(var(--stroke-width) * -0.7071) 0 var(--stroke-color),
  calc(var(--stroke-width) * 0.9239) calc(var(--stroke-width) * -0.3827) 0 var(--stroke-color);
}

.curve-text-div span {

  /* Calculate the interpolation factor (0 to 1) */
  --factor: calc(var(--i) / var(--total));

  --pos: calc(var(--i) / (var(--total) - 1) * 100);
  --t-raw: calc((var(--pos) - var(--pos-a)) / (var(--pos-b) - var(--pos-a)));
  --t: clamp(0, var(--t-raw), 1);

  /* Interpolate each channel */
  --r: calc(var(--start-r) + var(--t) * (var(--end-r) - var(--start-r )));
  --g: calc(var(--start-g) + var(--t) * (var(--end-g) - var(--start-g)));
  --b: calc(var(--start-b) + var(--t) * (var(--end-b) - var(--start-b)));
  --a: calc(var(--start-a) + var(--t) * (var(--end-a) - var(--start-a)));
  /*
    --r: calc(var(--start-r) + (var(--factor) * (var(--end-r) - var(--start-r))));
    --g: calc(var(--start-g) + (var(--factor) * (var(--end-r) - var(--start-g))));
    --b: calc(var(--start-b) + (var(--factor) * (var(--end-r) - var(--start-b))));
  */
  color: rgba(var(--r), var(--g), var(--b), var(--a));

}

</style>
